import React from 'react';
import Pluralize from 'pluralize';

import PageLayout from 'layouts/PageLayout';
import ListSearch from 'components/ListSearch';
import BasicButton from 'components/BasicButton';
import GridHistory from 'components/GridHistory';
import FiltersContentLoader from 'components/FiltersContentLoader';
import List from 'scenes/List/';
import Sidebar from 'scenes/Sidebar';
import EmailTemplateFollowupItem from 'scenes/List/components/EmailTemplateFollowupItem';
import ConfirmDialog from 'scenes/Dialog/components/ConfirmDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import InBoundsHistory from 'scenes/Sidebar/components/InBoundsHistory';

import { ROUTE_REGEXP } from 'constants/route';
import { ENDPOINT } from 'constants/endpoints';
import { useGrid } from 'hooks/useGrid';
import { updateHistory } from 'helpers/grid-history';
import { useApi } from 'hooks/useApi';

import './styles.css';

const ManageEmailsTemplates = props => {
  const { pageTitle, history } = props;

  const api = useApi();

  const grid = useGrid(ENDPOINT.COLLECTION.EMAIL_TEMPLATE_FOLLOWUP, params => {
    updateHistory(history, params);
  });

  const handleDelete = (id, count) => {
    ConfirmDialog({
      bodyRender:
        count > 0
          ? `This template is attached to ${count} ${Pluralize(
              'process',
              Number(count)
            )}. Are you sure you want to delete this template?`
          : 'Are you sure you want to delete this template?',
      dismissWhenClose: true,
      textSuccessBtn: 'Yes',
      textCancelBtn: 'No',
    }).then(() => {
      api.post(
        ENDPOINT.ACTION.EMAIL_TEMPLATE_FOLLOWUP.REMOVE,
        { id },
        {
          handleError: response => ResponseErrorDialog({ response }),
          handleSuccess: () => {
            grid.actions.fetch();
          },
        }
      );
    });
  };

  return (
    <GridHistory grid={grid} history={history}>
      <PageLayout
        pageClass="manage-emails-templates-page"
        pageTitle={pageTitle}
        mainContent={
          <>
            <ListSearch
              renderHeader={
                <div className="manage-emails-templates-page__header">
                  <h2 className="manage-emails-templates-page__title">
                    Create New Email Template
                  </h2>
                  <div className="manage-emails-templates-page__action">
                    <BasicButton
                      btnWidth={200}
                      btnHeight={45}
                      btnFontWeight={600}
                      btnText="Create Now"
                      btnArrow={true}
                      btnBg="#fff"
                      btnHoverBg="#f40"
                      controlFunc={() =>
                        history.push(
                          ROUTE_REGEXP.SEARCH_EMAILS_TEMPLATES_CREATE
                        )
                      }
                    />
                  </div>
                </div>
              }
              search={grid.data.params.search || false}
              searchPlaceholder="Search Template"
              onSendSearchQueryHandler={grid.actions.search}
            />

            <article className="emails-templates-list">
              <div className="page__description">
                <h3 className="page__subtitle">Manage Emails Templates</h3>
              </div>
              <List
                items={grid.data.rows}
                itemRender={(item, actions) => (
                  <EmailTemplateFollowupItem
                    key={item.EmailTemplateFollowupID}
                    onDelete={actions.onDelete}
                    data={item}
                  />
                )}
                actions={{
                  onChangePage: grid.actions.readPage,
                  onDelete: handleDelete,
                }}
                pagination={{
                  page: grid.data.page,
                  count: grid.data.rowsCount,
                  perPage: grid.data.perPage,
                }}
              />
            </article>
          </>
        }
        sidebarContent={
          grid.data.init ? (
            <Sidebar>
              <InBoundsHistory isRecruiter />
            </Sidebar>
          ) : (
            <FiltersContentLoader />
          )
        }
      />
    </GridHistory>
  );
};

export default ManageEmailsTemplates;
